import { render, staticRenderFns } from "./SepaTransferHistory.vue?vue&type=template&id=f371e66e&"
import script from "./SepaTransferHistory.vue?vue&type=script&lang=js&"
export * from "./SepaTransferHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports